module.exports = __webpack_public_path__ + "img/email-sent.a1fb004d.webp";